import {
    ActionBarContext,
    addActionBarItem,
    registerHistoryEntryComponent,
} from '@vendure/admin-ui/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

import { TaxIdHistoryEntryComponent } from './components/tax-id-history-entry.component';
import gql from 'graphql-tag';
import { map } from 'rxjs/operators';

const DEACTIVATE_ALL_PRODUCTS = gql`
    mutation DeactivateAllProducts($input: DeactivateAllProductsInput!) {
        deactivateAllProducts(input: $input) {
            success
        }
    }
`;

const productLoading$ = new BehaviorSubject(false);
export default [
    addActionBarItem({
        id: 'disable-branch-down-stock',
        label: 'Baixar estoque',
        locationId: 'channel-detail',
        icon: 'recycle',
        buttonState: (_context: ActionBarContext) => {
            return productLoading$
                .asObservable()
                .pipe(
                    map((isLoading) => ({ disabled: isLoading, visible: true }))
                );
        },
        onClick: async (_event, context) => {
            const channelId = context.route.snapshot.params.id;
            if (!channelId) {
                context.notificationService.error(
                    'ID do canal não encontrado na rota.'
                );
                return;
            }

            try {
                context.notificationService.info(
                    'Iniciando processo de baixar estoque...'
                );

                interface DeactivateAllProductsResponse {
                    deactivateAllProducts: {
                        success: boolean;
                    };
                }

                const res = await firstValueFrom(
                    context.dataService.mutate<DeactivateAllProductsResponse>(
                        DEACTIVATE_ALL_PRODUCTS,
                        {
                            input: { channelId },
                        }
                    )
                );

                const result = res?.deactivateAllProducts;
                if (result?.success) {
                    context.notificationService.success(
                        'Itens adicionados à fila de processamento.'
                    );
                } else {
                    context.notificationService.error('Falha ao processar.');
                }
            } catch (err: any) {
                context.notificationService.error('Erro: ' + err.message);
            } finally {
                productLoading$.next(false);
            }
        },
        requiresPermission: 'ReadChannel',
    }),
    registerHistoryEntryComponent({
        type: 'TaxIdHistoryEntry',
        component: TaxIdHistoryEntryComponent,
    }),
];
